/* Notification reference * resource
https://github.com/vuetifyjs/vuetify/issues/2384 * another implementation
https://www.npmjs.com/package/snackbarstack */
https://www.npmjs.com/package/vue-notification

<template>
  <div>
    <transition-group
      :key="notificationsRenderKey"
      :class="{'notification-mb-1':connectionLost, 'mb-18': appUpdateAvailable || soundsDisabled}"
      class="alerts-drawer-wrapper"
      
      name="alerts-drawer-wrapper"
      tag="div"
    >
      <template v-for="alert in notificationQueue">

        <v-card
          @click="alertClicked(alert)"
          class="alerts-snack rounded-lg elevation-8"
          :maxWidth="alert.text.length < 33 ? '300px' : '500px'"
          style="min-width: 288px !important;"
          :minWidth="$vuetify.breakpoint.xsOnly ? '80%' : '350px'"
          :color="alert.color"
          :key="alert.id"
        >
          <v-card-actions class="pl-4 pr-1" style="min-width: 288px !important;">
            <p class="mb-0" v-html="alert.text">
            </p>
            <p class="mb-0">
              <a v-if="link.length" :href="link" target="_blank">
                  <v-icon x-small :class="linkColor == 'error' ? 'hover-text-error' : 'hover-text-primary'" class="pl-1" style="display: inline-block; font-size:14px; padding-bottom: 4px;">far fa-question-circle</v-icon>
                </a>
            </p>
            <v-spacer />
            <v-btn
              color="grey lighten-3"
              icon
              @click.stop="dismiss(alert.id)"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { events } from "@/plugins/events.js";
import { mapGetters } from "vuex";

export default {
  name: "notifier",
  data() {
    return {
      notificationsRenderKey: 0,
      timeOut: 5000,
      notificationColor: "success",
      notificationText: "",
      notificationQueue: [],
      notification: false,
      goToPage: "",
      link: "",
      linkColor: "",
    };
  },
  props: {
    soundsDisabled: {
      type: Boolean,
      default: true,
    },
    mobileNotStandalone: {
      type: Boolean,
      default: false,
    },
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    },
    connectionLost: {
      type: Boolean,
      default: false,
    },
    appUpdateAvailable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stackAlerts: {
      get() {
        return this.getSpecificSetting({
          section: "general",
          innerSection: "notifications",
        }).stack;
      },
      set() {},
    },
    notificationTextsCombined() {
      if (this.notificationTexts.length > 1)
        return this.notificationTexts[0] + " " + this.notificationTexts[1];
      else return this.notificationTexts[0];
    },
    notificationTexts() {
      if (this.notificationText.length) return this.notificationText.split("|");
      else return [];
    },
    hasNotificationsPending() {
      return this.notificationQueue.length > 0;
    },
    ...mapGetters(["getSpecificSetting"]),
  },
  watch: {
    connectionLost(value) {
      if(this.notificationsRenderKey > 10) {
        this.notificationsRenderKey = 0
      } else this.notificationsRenderKey++
    }
    // notification() {
    //   if (!this.notification && this.hasNotificationsPending) {
    //     this.notificationText = this.notificationQueue.shift();
    //     this.$nextTick(() => (this.notification = true));
    //   }
    // },
  },
  methods: {
    dismiss(id) {
      let index = this.notificationQueue.findIndex(el => el.id == id)
      this.notificationQueue.splice(index,1)
    },
    alertClicked(alert) {
      let id = alert.id
      if(this.goToPage == '/price-guard') {
        this.$router.push(this.goToPage).catch((err) => {})
        let index = this.notificationQueue.findIndex(el => el.id == id)
        this.notificationQueue.splice(index,1)
      } else if(this.goToPage == '/trade-watcher') {
        if(alert.hasOwnProperty('extraArg')) {
            this.dismiss(id)
            events.$emit("focus-on-new-alert", alert.extraArg.value)
        }
      }
    },
    notifyOverrideAlerts(text, color, extraArg = null) {
      if(this.notificationQueue.length) {
        // let length = this.notificationQueue.length
        // for(let i = 0; i < length; i++) {
        //   this.notificationQueue.splice(i,1)
        // }
        this.notificationQueue = []
        // this.notificationQueue.pop()
      }

      let newAlert = {
          id: this.getUniqueId(this.notificationQueue),
          model: true,
          text: text,
          color: color,
          createdOn: new Date().getTime(),
        }
      
      if(extraArg) {
        newAlert.extraArg = JSON.parse(JSON.stringify(extraArg))
      }


      this.$nextTick(() => {
        this.notificationQueue.push(newAlert);
      });
    },
    notifyStackedAlerts(text, color, extraArg = null) {
      if (this.notificationQueue.length > 5) {
        let removeItems = this.notificationQueue.length - 5;
        for (let i = 0; i < removeItems; i++) {
          this.notificationQueue.splice(i, 1);
        }
      }

      let newAlert = {
        id: this.getUniqueId(this.notificationQueue),
        model: true,
        text: text,
        color: color,
        createdOn: new Date().getTime(),
      }

      if(extraArg) {
        newAlert.extraArg = JSON.parse(JSON.stringify(extraArg))
      }

      this.notificationQueue.push(newAlert);
    },
    removeTimedOut() {
      let currentTime = new Date().getTime();
      let indexesToRemove = [];
      this.notificationQueue.forEach((el, i) => {
        if (currentTime - el.createdOn > this.timeOut) {
          indexesToRemove.push(i);
        }
      });
      if (indexesToRemove.length) {
        indexesToRemove.forEach((index) => {
          this.notificationQueue.splice(index, 1);
        });
      }
    },
    getUniqueId(arr) {
      if (arr.length) {
        let maxVal = -1;
        arr.forEach((el) => {
          if (el.id > maxVal) maxVal = el.id;
        });
        return maxVal + 1;
      } else {
        return Math.floor(Math.random() * (1000 - 0 + 1) + 0);
      }
    },
    notify(text, color, extraArg = null) {
      if (this.stackAlerts) {
        this.notifyStackedAlerts(text, color, extraArg);
      } else {
        this.notifyOverrideAlerts(text, color, extraArg);
      }

    },
  },
  mounted() {
    setInterval(() => {
      this.removeTimedOut();
    }, 1000);

    events.$on("notify", (details) => {
        if (details.link) {
          this.link = details.link;
          this.linkColor = details.color;
        } else this.link = "";

        if(details.alertId != null) {
          this.notify(details.message, details.color, {value: details.alertId});
        } else {
          this.notify(details.message, details.color);
        }
        if(details.goToPage)
          this.goToPage = details.goToPage;
        else 
          this.goToPage = "";

    });
  },
};
</script>
<style lang="sass">
.alerts-drawer-wrapper
  max-width: 350px
  display: flex
  flex-direction: column
  justify-content: flex-end
  position: fixed
  pointer-events: none
  bottom: 0px
  left: 10px
  z-index: 1000
  > .alerts-snack
    color: #fff
    margin-bottom: 15px
    pointer-events: auto
    transition: all .5s
  &-enter, &-leave-to, &-leave-active
    opacity: 0
  &-leave-active
    position: fixed
</style>
<style>
@media (max-width: 600px) {
  .alerts-drawer-wrapper {
    left: 50%;
    transform: translateX(-50%);
  }
}
.alerts-snack p:first-child {
  max-width: 300px;
}
.align-snackbar .v-snack__wrapper {
  margin-left: auto;
  margin-right: auto;
}
.notification-mb-1 {
  margin-bottom: 76px !important; 
}
</style>
